export default __webpack_public_path__ + "static/media/coding2.ab43dfc0.gif";